import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import Button from '@vtex/styleguide/lib/Button'
import Modal from '@vtex/styleguide/lib/Modal'

import ModalTitle from '@/checkout-instore-legacy/components/Commons/ModalTitle'
import * as PaymentUtils from '@/checkout-instore-legacy/utils/PaymentUtils'
import { withMediaQuery } from '@/checkout-instore-legacy/utils/mediaQuery'
import NumberInput from '../NumberInput'
import Price from '../Price'

class ProductManualPrice extends Component {
  constructor(props) {
    super(props)
    this.state = {
      price:
        props.manualPrice !== null && props.manualPrice !== undefined
          ? props.manualPrice
          : null,
      errorPriceBigger: false,
    }
  }

  handlePriceChange = (price) => {
    this.setState({ price })
  }

  handleFormSubmit = (e) => {
    e.preventDefault()
    this.props.onChange(this.state.price)
  }

  render() {
    const { mediaQuery } = this.props
    const originalPrice =
      this.props.originalPrice !== null &&
      this.props.originalPrice !== undefined
        ? this.props.originalPrice
        : this.state.price
    const currencySymbol = PaymentUtils.getCurrencySymbol()
    const isDesktop = mediaQuery({
      phone: false,
      tablet: false,
      desktop: true,
    })

    return (
      <Modal
        centered
        isOpen={this.props.isVisible}
        onClose={this.props.onClose}
      >
        <div className="tc f4-ns">
          <ModalTitle id="productManualPriceTitle" label={this.props.name} />
          <form onSubmit={this.handleFormSubmit}>
            <div className="silver mv4 db fw3 db">
              <FormattedMessage id="productOriginalPrice" />
            </div>
            <div id="productmanualprice-original-price" className="mb5 mb6-ns">
              <Price value={originalPrice} />
            </div>

            <label htmlFor="manualPrice" className="silver mv4 db fw3 db">
              <FormattedMessage id="productNewPrice" />
            </label>
            <div className="value-content tl">
              <label htmlFor="manualPrice">{currencySymbol}</label>
              <NumberInput
                id="manualPrice"
                className={`ba w-40 w-30-ns pa4 lh-copy tc ml4 ${
                  this.state.errorPriceBigger ? 'b--light-red' : 'b--black-20'
                }`}
                value={this.state.price}
                onChange={this.handlePriceChange}
              />
            </div>
            {this.state.errorPriceBigger ? (
              <div id="productmanualprice-error" className="mt5 light-red f6">
                <FormattedMessage id="productPriceShouldBeLower" />
              </div>
            ) : null}

            <div className="flex justify-end mt7">
              <Button
                id="productmanualprice-submit"
                type="submit"
                variation="primary"
                block={!isDesktop}
              >
                <FormattedMessage id="productChangePrice" />
              </Button>
            </div>
          </form>

          <div className="pa5 pa6-ns tc gray f6 f5-ns lh-copy">
            <FormattedMessage id="productManualPriceAlert" />
          </div>
        </div>
      </Modal>
    )
  }
}

ProductManualPrice.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  originalPrice: PropTypes.number,
  manualPrice: PropTypes.number,
  name: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  mediaQuery: PropTypes.func.isRequired,
}

export default withMediaQuery(ProductManualPrice)
